<app-modal [dismissible]="false" class="tool-property-validation-info-modal">
    <div class="modal-header" modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <p class="message">{{ message }}</p>
        <ul class="tools-list" *ngIf="tools?.length">
            <li *ngFor="let tool of tools">
                <span>{{ tool.name }} - {{ tool.toolUid }}</span>
            </li>
        </ul>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple" (clicked)="close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary" (clicked)="onConfirm()">
            {{ 'generic.buttons.confirm' | translate }}
        </app-button>
    </div>
</app-modal>
